import { createContext } from 'react';

export const VisitContext = createContext({
  placeData: { placeId: '', tableId: '' },
  dataForPage: { place: {}, table: {} },
  getDataForVisitPage: ({ placeId, tableId }) => {},
});
